import { FC, PropsWithChildren, useEffect } from 'react'

export namespace Segment {
  type EventType = 'Click' | 'Page View' | 'Song Uploaded'

  export const track = (type: EventType, attributes: { [key: string]: number | string }) => {
    window.analytics.track(type, attributes)
  }

  interface PageViewAttributes {
    path: string
    [key: string]: number | string
  }

  export const trackPageView = (attributes: PageViewAttributes) => {
    track('Page View', attributes)
  }

  export const ViewTracker: FC<PropsWithChildren<{ attributes: PageViewAttributes }>> = ({
    attributes,
    children
  }) => {
    useEffect(() => {
      trackPageView(attributes)
    }, [])
    return <>{children}</>
  }
}
